export default [{
    "id": 0,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fyt3.ggpht.com%2Fa%2FAGF-l79G_ZKAHD8GSmWtOb2qzNz1pcC0JU0v5Jul6g%3Ds900-mo-c-c0xffffffff-rj-k-no&f=1&nofb=1",
    "name":"Naruto",
    "toggle": false
},
{
    "id": 1,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmangathrill.com%2Fwp-content%2Fuploads%2F2019%2F07%2Fereee.jpg&f=1&nofb=1",
    "name":"Eren",
    "toggle": false
},
{
    "id": 2,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fotakukart.com%2Fwp-content%2Fuploads%2F2020%2F12%2Fjuju.jpg&f=1&nofb=1",
    "name":"Yuji",
    "toggle": false
},
{
    "id": 3,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fi.ytimg.com%2Fvi%2F9X0vj15zr38%2Fmaxresdefault.jpg&f=1&nofb=1",
    "name":"Satoru",
    "toggle": false
},
{
    "id": 4,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fi.pinimg.com%2Foriginals%2F88%2F2f%2F17%2F882f17229ed78b7da7d100f0efea6767.jpg&f=1&nofb=1",
    "name":"Nobara",
    "toggle": false
},
{
    "id": 5,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.1am-pD86ufnAOKINr2B5kwHaGl%26pid%3DApi&f=1",
    "name":"Mikasa",
    "toggle": false
},
{
    "id": 6,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fimage.winudf.com%2Fv2%2Fimage%2FY29tLmFuZHJvbW8uZGV2NjYwNjE0LmFwcDc1MDYxNl9zY3JlZW5fMTFfMTUyMDAwMDQxN18wMTI%2Fscreen-11.jpg%3Ffakeurl%3D1%26type%3D.jpg&f=1&nofb=1",
    "name":"Hinata",
    "toggle": false
},
{
    "id": 7,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fvignette.wikia.nocookie.net%2Fkingdomheartsfanon%2Fimages%2F3%2F39%2FPhoto_(3).jpg%2Frevision%2Flatest%3Fcb%3D20120829223245&f=1&nofb=1",
    "name":"Sasuke",
    "toggle": false
},
{
    "id": 8,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fi.pinimg.com%2Foriginals%2F63%2Fb6%2Fc2%2F63b6c2b74aec8752107435e763aa6607.jpg&f=1&nofb=1",
    "name":"Panda",
    "toggle": false
},
{
    "id": 9,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2F1.bp.blogspot.com%2F-8070srcHS88%2FWvWzbDyLslI%2FAAAAAAAAFsk%2FLg-yLqEqVXUA85V72UU62bGK2pXpn6KugCLcBGAs%2Fw1200-h630-p-k-no-nu%2FIzuku%2BMidoriya%2BMy%2BHero%2BBoku%2Bno%2BBNHA%2BMHA%2Bacademia%2Banime%2Bnew%2Bepisode%2Bmanga%2Bdeku%2Ball%2Bmight%2Bblog%2Bblogspot.png&f=1&nofb=1",
    "name":"Izuku",
    "toggle": false
},
{
    "id": 10,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.8S00PZpUyPo-svInn26B-QAAAA%26pid%3DApi&f=1",
    "name":"Toshinori",
    "toggle": false
},
{
    "id": 11,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fi.pinimg.com%2Foriginals%2F3b%2Fcb%2F71%2F3bcb710843105fdc6e8f03077533f507.jpg&f=1&nofb=1",
    "name":"Katsuki",
    "toggle": false
},
{
    "id": 12,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fi.ytimg.com%2Fvi%2F_5J8XRGyJro%2Fmaxresdefault.jpg&f=1&nofb=1",
    "name":"Kirigaya",
    "toggle": false
},
{
    "id": 13,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse3.mm.bing.net%2Fth%3Fid%3DOIP.ftv8i1weyNy6EnsCR5RwcgHaKc%26pid%3DApi&f=1",
    "name":"Asuna ",
    "toggle": false
},
{
    "id": 14,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.anime-planet.com%2Fimages%2Fcharacters%2Fzero-two-136345.jpg%3Ft%3D1552710628&f=1&nofb=1",
    "name":"Zero",
    "toggle": false
},
{
    "id": 15,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.ewJV_HbDZHTITzKx88WXZAHaEK%26pid%3DApi&f=1",
    "name":"Tanjiro",
    "toggle": false
},
{
    "id": 16,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fi.pinimg.com%2F736x%2Fc8%2Faf%2F52%2Fc8af52b1cdc4d4a138a501d974f88324.jpg&f=1&nofb=1",
    "name":"Nezuko",
    "toggle": false
},
{
    "id": 17,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fstatic.wikia.nocookie.net%2Fkimetsu-no-yaiba%2Fimages%2F8%2F85%2FSenjuro_anime.png%2Frevision%2Flatest%2Fscale-to-width-down%2F350%3Fcb%3D20201025191554&f=1&nofb=1",
    "name":"Senjuro",
    "toggle": false
},
{
    "id": 18,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fimgix.ranker.com%2Flist_img_v2%2F1374%2F2681374%2Foriginal%2Fthe-best-hisoka-quotes%3Fw%3D817%26h%3D427%26fm%3Djpg%26q%3D50%26fit%3Dcrop&f=1&nofb=1",
    "name":"Hisoka",
    "toggle": false
},
{
    "id": 19,
    "img": "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.Hb9vCKu2HZ42BRGi_PnWBwHaEK%26pid%3DApi&f=1",
    "name":"Gon",
    "toggle": false
}

]